import React from "react";
import { Row, Col, Badge } from "reactstrap";
import { beddowsToDecimal } from "../utils/lisk/utils/lisk/beddowsToDecimal";
import { generateAffiliationLabel } from "../utils/delegateAffiliation";
import { delegateLogo } from "../utils/logos/DelegateLogo";
import { delegateStatusColor } from "./utils/colorStatus";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";

let elementStyle = {
  maxHeight: "4rem",
  padding: "10px",
  borderTop: "#ffffff1f 1px solid",
  color: "rgba(255,255,255,0.7)",
  transition: "all 0.4s ease-out",
  opacity: 1,
};
const badge = {
  backgroundColor: "none",
  border: "1px solid #ffffff1f",
  color: "#efefef",
};
const avatarStyle = {
  width: "25px",
  height: "25px",
  borderRadius: "25px",
  marginRight: "10px",
};

interface Props {
  rank: string;
  address: string;
  missedBlocks: string;
  producedBlocks: string;
  rewards: string;
  vote: string;
  username: string;
  affiliation: string;
}

export const DelegatesElement: React.FC<Props> = ({
  rank,
  address,
  missedBlocks,
  producedBlocks,
  rewards,
  vote,
  username,
  affiliation,
}) => {
  const affiliationLabels = generateAffiliationLabel(affiliation);
  const productivity = (
    ((+producedBlocks - +missedBlocks) / +producedBlocks) *
    100
  ).toFixed(2);
  return (
    <tr>
      <th scope="row">
        <Badge
          pill
          // color={parseInt(rank) > 101 ? "link" : "info"}
          color={parseInt(rank) > 101 ? "link" : "info"}
          style={{ ...badge }}
        >
          {rank}
        </Badge>
      </th>
      <td>
        {/*<img src={logo} style={avatarStyle} alt="avatar" /> &nbsp;*/}
        {delegateLogo({ delegateName: username, style: avatarStyle })}
        <Link to={`/account/${username}`}>
          <strong>{username}</strong>
        </Link>
      </td>
      <td>{affiliationLabels}</td>
      <td>{(+beddowsToDecimal(vote)).toLocaleString()} Ⱡ</td>
      <td>{producedBlocks}</td>
      <td>
        {!isNaN(productivity as any) ? `${productivity} %` : "Never forged"}
      </td>
      <td>{delegateStatusColor(rank)}</td>
    </tr>
  );
};
